import RestService from '../services/rest';

async function getListCoursesAndTraining(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/coursesAndTraining/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getCsvCoursesAndTraining() {
  const response = await RestService.getAuthenticated('panel/coursesAndTraining/csv/model', { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'courses-and-training-model.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvCoursesAndTraining(file) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated('panel/coursesAndTraining/csv/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function uploadCoursesAndTraining(coursesAndTrainingParameter) {
  return RestService.putAuthenticated('panel/coursesAndTraining/update', coursesAndTrainingParameter);
}

async function deleteCoursesAndTraining(coursesAndTrainingId) {
  return RestService.deleteAuthenticated('panel/coursesAndTraining/delete', { coursesAndTrainingId });
}

export default {
  getListCoursesAndTraining,
  getCsvCoursesAndTraining,
  uploadCsvCoursesAndTraining,
  uploadCoursesAndTraining,
  deleteCoursesAndTraining,
};
